import type { SVGProps } from "react";

export function CTAArrow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="cta-arrow"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        d="M3 8H17M17 8L13 4M17 8L13 12"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
